import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components.v2/Text'
import imageURL from 'utils/imageURL'
import {
  MenuCardContainer,
  MenuCardBody,
  MenuCardFooter,
  MenuAddToCart,
  MenuImage,
  MenuContent,
  Description,
  MenuPlus,
  Name,
} from './styled'

class MenuCard extends React.PureComponent {
  state = {
    imageSrc: null,
  }

  image = null

  pickMenu = () => {
    this.props.openModal(this.props.menu)
  }

  componentDidMount = () => {
    this.loadImage()
  }

  componentWillUnmount = () => {
    this.image = null
  }

  loadImage = () => {
    const imageSrc = imageURL(this.props.menu.thumb, {
      width: 100,
      height: 100,
    })
    this.image = new Image()
    this.image.src = imageSrc
    this.image.onload = () => {
      if (this.image) {
        this.setState({
          imageSrc,
        })
      }
    }
    this.image.onerror = () => {
      if (this.image) {
        this.setState({
          imageSrc: null,
        })
      }
    }
  }

  render = () => {
    const { name, description, price } = this.props.menu
    return (
      <MenuCardContainer onClick={this.pickMenu}>
        <MenuCardBody>
          <MenuContent>
            <Name variant="secondary" bold className="menu-card-title">
              {name}
            </Name>
            <Description
              className="menu-card-desc"
              variant="tertiary"
              color="textLight"
              light
            >
              {description}
            </Description>
            <Text
              variant="secondary"
              className="menu-card-price"
              color="textSecondary"
              bold
            >
              {price}
            </Text>
          </MenuContent>
          {this.state.imageSrc && <MenuImage image={this.state.imageSrc} />}
        </MenuCardBody>
        <MenuCardFooter>
          <MenuAddToCart>
            <Text variant="tertiary" color="textDark" light>
              Add to cart
            </Text>
          </MenuAddToCart>
          <MenuPlus>&#43;</MenuPlus>
        </MenuCardFooter>
      </MenuCardContainer>
    )
  }
}

MenuCard.propTypes = {
  openModal: PropTypes.func,
  menu: PropTypes.object,
}

MenuCard.defaultProps = {
  openModal: () => {},
  menu: {},
}

export default MenuCard
